module.exports = __webpack_public_path__ + "img/oficina.8f0754e6.svg";